// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.ContactUsFormContainer{
    /* background-color: aqua; */

    display: flex;
    justify-content: space-around;
    margin-bottom: 30px;
   
}

.ContactUsFormCardCover{

    /* background-color: red; */
    padding: 30px;
}
.ContactUsFormCardCover p{

    padding: 0;
    margin: 0;
}

.WholeNamesContainers{

    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    /* padding: 30px; */
}

.EmailInput{
    /* min-width: 500px; */
    width: 100%;
}

.topicsOfInterestsCheck{
    
}
.topicsOfInterestsCheck p{

    padding: 30px 0;
}
.topicsOfInterestsCheck input{

    margin-right: 20px;
}

.moreinfoSubmit {

   margin-top: 20px;

}
.moreinfoSubmit button{

    border: none;
    padding: 8px 24px;
    background-color: #003300;
    color: white;
    cursor: pointer;

}
.moreinfoSubmit button:hover{

    background-color: black;
  

}`, "",{"version":3,"sources":["webpack://./src/Components/ContactUsForm/ContactUsForm.css"],"names":[],"mappings":";;AAEA;IACI,4BAA4B;;IAE5B,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;;AAEvB;;AAEA;;IAEI,2BAA2B;IAC3B,aAAa;AACjB;AACA;;IAEI,UAAU;IACV,SAAS;AACb;;AAEA;;IAEI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;;AAEA;AACA;;IAEI,eAAe;AACnB;AACA;;IAEI,kBAAkB;AACtB;;AAEA;;GAEG,gBAAgB;;AAEnB;AACA;;IAEI,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,eAAe;;AAEnB;AACA;;IAEI,uBAAuB;;;AAG3B","sourcesContent":["\n\n.ContactUsFormContainer{\n    /* background-color: aqua; */\n\n    display: flex;\n    justify-content: space-around;\n    margin-bottom: 30px;\n   \n}\n\n.ContactUsFormCardCover{\n\n    /* background-color: red; */\n    padding: 30px;\n}\n.ContactUsFormCardCover p{\n\n    padding: 0;\n    margin: 0;\n}\n\n.WholeNamesContainers{\n\n    display: flex;\n    justify-content: space-between;\n    margin-top: 20px;\n    /* padding: 30px; */\n}\n\n.EmailInput{\n    /* min-width: 500px; */\n    width: 100%;\n}\n\n.topicsOfInterestsCheck{\n    \n}\n.topicsOfInterestsCheck p{\n\n    padding: 30px 0;\n}\n.topicsOfInterestsCheck input{\n\n    margin-right: 20px;\n}\n\n.moreinfoSubmit {\n\n   margin-top: 20px;\n\n}\n.moreinfoSubmit button{\n\n    border: none;\n    padding: 8px 24px;\n    background-color: #003300;\n    color: white;\n    cursor: pointer;\n\n}\n.moreinfoSubmit button:hover{\n\n    background-color: black;\n  \n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
